import { render } from "./AssignmentSubmission.vue?vue&type=template&id=db022fba"
import script from "./AssignmentSubmission.vue?vue&type=script&lang=js"
export * from "./AssignmentSubmission.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__